import axiosClient from '../axiosClient';
import { PUT_RESET_NON_NATIONAL_EXAM_VACANCY_PAYMENT_EXPIRY } from '../../constants/apiUrls';
import { useCustomMutation } from '../utils/useCustomMutation';

interface Input {
  uuid: string;
  onSettled?: () => void;
}

export const usePutResetNonNationalVacancyPaymentExpiry = ({ uuid, onSettled }: Input) => {
  const putResetNonNationalVacancyPaymentExpiry = async () => {
    const res = await axiosClient.put<void>(
      PUT_RESET_NON_NATIONAL_EXAM_VACANCY_PAYMENT_EXPIRY(uuid)
    );
    return res.data;
  };

  return useCustomMutation(putResetNonNationalVacancyPaymentExpiry, {
    onSettled,
  });
};
